<template>
  <!-- 讲师介绍  -->
  <div class="coursedescription">
    <div class="box">
      <h5 class="isintroduced">讲师介绍</h5>
      <div class="box-x">
        <div class="imgss">
          <img
            @click="teacherjump(itemsa)"
            :src="http + itemsa.user.tx"
            alt=""
            class="imgssa"
          />
          <div class="hetitle">
            <h5 class="titlezc" @click="teacherjump(itemsa)">
              {{ itemsa.user.name }}
            </h5>
            <p>
              <img
                src="../../../assets/The-title.png"
                alt=""
                class="imgsccs"
              /><span
                @click="teacherjump(itemsa)"
                v-for="item in itemsa.user.userzc"
                :key="item.id"
              >
                {{ item.zcname }}
              </span>
            </p>
          </div>
        </div>
        <div align="left" class="introduce" @click="teacherjump(itemsa)">
          &nbsp;&nbsp;&nbsp;&nbsp; {{ itemsa.user.iresume }}
        </div>
      </div>
      <!-- <h5 class="isintroduced">相关课程</h5> -->
      <!-- <div class="buttom">
        <ul class="Course">
          <li class="Live1" v-for="(iten, index) in tableData" :key="index">
            <video
              @click="umpis(iten)"
              class="videois"
              :src="htto + iten.sp"
            ></video>
            <div class="thevideo">
              <h4 @click="umpis(iten)">{{ iten.name }}</h4>
              <p class="wb" @click="umpis(iten)" v-html="iten.kcjs">
                {{ iten.kcjs }}
              </p>
              <div class="jejq">
                <span class="je">{{ iten.jg }}</span>
                <div>
                  <i class="iconfont gos-yanjing1"></i>
                  <span class="dzs">浏览量：{{ iten.ll }}</span>
                </div>
              </div>
              <div class="collection">
                <span @click="teacherjump(itemsa)"
                  ><img
                    class="imgswa"
                    :src="http + itemsa.jsjs.tx"
                    alt=""
                  />&nbsp; &nbsp;{{ itemsa.jsjs.name }}</span
                >
                <button
                  v-if="iten.jg !== '免费'"
                  @click="umpis(iten)"
                  class="Buynow"
                >
                  立即购买
                </button>
                <button
                  v-if="iten.jg == '免费'"
                  @click="umpis(iten)"
                  class="Buynow"
                >
                  立即查看
                </button>
              </div>
            </div>
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>
<script>
// import Bus from '@/utils/bus'
import { sellsitem } from "../../../api/patient";
// import Bus from '@/utils/bus'
export default {
  data() {
    return {
      tableData: "",
      itemsa: {
        gm: "",
        id: "",
        itemtime: "",
        jg: "",
        jsjs: "",
        kcjs: "",
        ll: "",
        name: "",
        pf: "",
        plcyrs: "",
        plts: "",
        rjxz: {
          bhrjbb: [],
          id: "",
          rjjj: "",
          rjlb: "",
          rjmc: "",
          rjsm: "",
          rjsm1: "",
          rjsp: "",
          rjsp1: "",
          rjtb: "",
          rjtb1: "",
          softwaretime: "",
        },
        sc: "",
        scrq: "",
        softwareid: "",
        sort: "",
        sp: "",
        sp1: "",
        status: "",
        tsy: "",
        userid: "",
        xj: "",
      },
      dialogVisible: false,
      tepform: "",
      http: this.$store.state.https,
      htto: this.$store.state.https,
      thisa: "",
    };
  },
  created() {
    this.selitemid();
    // this.sellsitemis();
  },
  mounted() {
    // Bus.$emit('activeIndexss', '/coursedescription')
  },
  methods: {
    // 跳转老师详情页
    teacherjump(item) {
      this.$router.push(`/TeacherDetailsPage/${item.jsjs.id}`);
    },
    // 跳转
    umpis(item) {
      // this.goTop()
      this.$router.go();
      this.$router.push("/coursedetailspage");
      this.$store.commit("Jumpfordetails", item.id);
    },
    goTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    // 获取老师相关分类
    // sellsitemis() {
    //   var data = new FormData();
    //   data.append("id", this.itemsa.user.id);
    //   data.append("page", 1);
    //   data.append("rows", 3);
    //   data.append("sort", this.itemsa.sort);
    //   data.append("status", "已通过");
    //   sellsitem(data).then((res) => {
    //     this.tableData = res.rows;
    //   });
    // },
    selitemid() {
      var a = sessionStorage.itemss;
      this.itemsa = JSON.parse(a);
    },
  },
  watch: {},
};
</script>
<style scoped lang="scss">
.coursedescription {
  width: 100%;
  .box {
    margin: 0 auto;
    width: 687px;
  }
}
.isintroduced {
  margin-top: 25px;
  margin-bottom: 19px;
  // width: 56px;
  text-align: left;
  padding-left: 10px;
  border-left: 2px solid #4ccaff;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
}
.box-x {
  width: 687px;
  // height: 161px;
  background: #ffffff;
  border: 1px solid #f3f3f3;
  border-radius: 6px;
  .introduce {
    margin-left: 58px;
    margin-top: 19px;
    max-width: 605px;
    margin-bottom: 40px;
    word-break: break-all;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    line-height: 25px;
  }
}
.imgss {
  display: flex;
}
.imgssa {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  margin-top: 21px;
  margin-left: 21px;
}
.hetitle {
  text-align: left;
  margin-left: 12px;
  margin-top: 25px;
}
.imgsccs {
  width: 14px;
  height: 14px;
  margin-right: 8px;
}
.titlezc {
  margin-bottom: 8px;
}
.buttom {
  margin-top: 27px;
  .Course {
    display: flex;
    width: 100%;
    justify-content: left;
    // flex-wrap: wrap;
    .Live1 {
      width: 218px;
      height: 264px;
      background: #ffffff;
      border: 1px solid #f6f6f6;
      border-radius: 6px;

      margin-bottom: 20px;
      transition: all 0.2s;
      margin-left: 17px;
      .thevideo {
        display: flex;
        flex-direction: column;
        padding: 5px 20px;
        h4 {
          white-space: nowrap;
          // width: 126px;
          display: flex;
          width: 107px;
          height: 12px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
        }
        .wb {
          // text-indent:2rem;
          word-break: break-all;
          font-size: 10px;
          transform: scale(1);
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          line-height: 17px;
          display: flex;
          text-align: left;
          margin-top: 10px;
          width: 180px;
          height: 34px;
          // height: 34px;
          display: -webkit-box; /**对象作为伸缩盒子模型展示**/
          -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
          -webkit-line-clamp: 2; /**显示的行数**/
          overflow: hidden; /**隐藏超出的内容**/
        }
        .jejq {
          margin-top: 5px;
          display: flex;
          justify-content: space-between;
          .je {
            width: 66px;
            text-align: left;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ff1616;
          }
          div {
            display: flex;
            img {
              width: 12px;
              height: 12px;
              line-height: 12px;
              margin-right: 8px;
              padding-top: 2px;
            }
          }
        }
        .collection {
          border-top: 1.5px solid #f6f6f6;
          padding-top: 7px;
          margin-top: 5px;
          display: flex;
          justify-content: space-between;
          .dzs {
            white-space: nowrap;
            height: 13px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
          }
          .Buynow {
            white-space: nowrap;
            // display: flex;
            text-align: center;
            width: 67px;
            height: 23px;
            background: #4ccaff;
            border-radius: 4px;
            border: 1px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }
    .Live1:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
    }
  }
  .el-pagination {
    margin-top: 60px;
    margin-bottom: 30px;
  }
}
.videois {
  width: 218px;
  height: 133px;
  border-radius: 6px 6px 0px 0px;
}
.titlezc {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #4ccaff;
}
.imgsccs {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}
.dzs {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}
.imgswa {
  width: 22px;
  height: 22px;
  border-radius: 50%;
}
.gos-yanjing1 {
  color: rgb(153, 153, 153);
  line-height: 20px;
  margin-right: 5px;
}
.el-pagination {
  ::v-deep span {
    padding: 0 10px;
  }
}
// 适配手机端
@media (max-width: 768px) {
  .coursedescription {
    width: 100%;
    .box {
      margin: 0 auto;
      width: 95vw;
    }
  }
  .box-x {
    width: 95vw;
  }
}
</style>
